export default {
  /* AWS Accounts */
  AWS_GET_ACCOUNTS: 'AWS_GET_ACCOUNTS',
  AWS_GET_ACCOUNTS_SUCCESS: 'AWS_GET_ACCOUNTS_SUCCESS',
  AWS_GET_ACCOUNTS_ERROR: 'AWS_GET_ACCOUNTS_ERROR',
  AWS_GET_ACCOUNTS_CLEAR: 'AWS_GET_ACCOUNTS_CLEAR',

  /* Bills Repositories */
  AWS_GET_ACCOUNT_BILLS: 'AWS_GET_ACCOUNT_BILLS',
  AWS_GET_ACCOUNT_BILLS_SUCCESS: 'AWS_GET_ACCOUNT_BILLS_SUCCESS',
  AWS_GET_ACCOUNT_BILLS_ERROR: 'AWS_GET_ACCOUNT_BILLS_ERROR',
  AWS_GET_ACCOUNT_BILLS_CLEAR: 'AWS_GET_ACCOUNT_BILLS_CLEAR',

  /* New AWS Account */
  AWS_NEW_ACCOUNT: 'AWS_NEW_ACCOUNT',
  AWS_NEW_ACCOUNT_SUCCESS: 'AWS_NEW_ACCOUNT_SUCCESS',
  AWS_NEW_ACCOUNT_ERROR: 'AWS_NEW_ACCOUNT_ERROR',
  AWS_NEW_ACCOUNT_CLEAR: 'AWS_NEW_ACCOUNT_CLEAR',

  /* New Bill Repository */
  AWS_NEW_ACCOUNT_BILL: 'AWS_NEW_ACCOUNT_BILL',
  AWS_NEW_ACCOUNT_BILL_SUCCESS: 'AWS_NEW_ACCOUNT_BILL_SUCCESS',
  AWS_NEW_ACCOUNT_BILL_ERROR: 'AWS_NEW_ACCOUNT_BILL_ERROR',
  AWS_NEW_ACCOUNT_BILL_CLEAR: 'AWS_NEW_ACCOUNT_BILL_CLEAR',

  /* Get Bill Repository Status */
  AWS_GET_ACCOUNT_BILL_STATUS: 'AWS_GET_ACCOUNT_BILL_STATUS',
  AWS_GET_ACCOUNT_BILL_STATUS_SUCCESS: 'AWS_GET_ACCOUNT_BILL_STATUS_SUCCESS',
  AWS_GET_ACCOUNT_BILL_STATUS_ERROR: 'AWS_GET_ACCOUNT_BILL_STATUS_ERROR',
  AWS_GET_ACCOUNT_BILL_STATUS_CLEAR: 'AWS_GET_ACCOUNT_BILL_STATUS_CLEAR',

  /* External */
  AWS_NEW_EXTERNAL: 'AWS_NEW_EXTERNAL',
  AWS_NEW_EXTERNAL_SUCCESS: 'AWS_NEW_EXTERNAL_SUCCESS',
  AWS_NEW_EXTERNAL_ERROR: 'AWS_NEW_EXTERNAL_ERROR',

  /* Edit AWS Account */
  AWS_EDIT_ACCOUNT: 'AWS_EDIT_ACCOUNT',
  AWS_EDIT_ACCOUNT_SUCCESS: 'AWS_EDIT_ACCOUNT_SUCCESS',
  AWS_EDIT_ACCOUNT_ERROR: 'AWS_EDIT_ACCOUNT_ERROR',

  /* Edit Bill Repository */
  AWS_EDIT_ACCOUNT_BILL: 'AWS_EDIT_ACCOUNT_BILL',
  AWS_EDIT_ACCOUNT_BILL_SUCCESS: 'AWS_EDIT_ACCOUNT_BILL_SUCCESS',
  AWS_EDIT_ACCOUNT_BILL_ERROR: 'AWS_EDIT_ACCOUNT_BILL_ERROR',
  AWS_EDIT_ACCOUNT_BILL_CLEAR: 'AWS_EDIT_ACCOUNT_BILL_CLEAR',

  /* Delete Account */
  AWS_DELETE_ACCOUNT: 'AWS_DELETE_ACCOUNT',
  AWS_DELETE_ACCOUNT_SUCCESS: 'AWS_DELETE_ACCOUNT_SUCCESS',
  AWS_DELETE_ACCOUNT_ERROR: 'AWS_DELETE_ACCOUNT_ERROR',

  /* Delete Bill Repository */
  AWS_DELETE_ACCOUNT_BILL: 'AWS_DELETE_ACCOUNT_BILL',
  AWS_DELETE_ACCOUNT_BILL_SUCCESS: 'AWS_DELETE_ACCOUNT_BILL_SUCCESS',
  AWS_DELETE_ACCOUNT_BILL_ERROR: 'AWS_DELETE_ACCOUNT_BILL_ERROR',

  /* Account Selection */
  AWS_SELECT_ACCOUNT: 'AWS_SELECT_ACCOUNT',
  AWS_CLEAR_ACCOUNT_SELECTION: 'AWS_CLEAR_ACCOUNT_SELECTION',

  /* LocalStorage */
  AWS_LOAD_SELECTED_ACCOUNTS: 'AWS_LOAD_SELECTED_ACCOUNTS',
  AWS_LOAD_SELECTED_ACCOUNTS_ERROR: 'AWS_LOAD_SELECTED_ACCOUNTS_ERROR',
  AWS_INSERT_SELECTED_ACCOUNTS: 'AWS_INSERT_SELECTED_ACCOUNTS',

  /* Get Shared Account */
  AWS_GET_ACCOUNT_VIEWERS: 'AWS_GET_ACCOUNT_VIEWERS',
  AWS_GET_ACCOUNT_VIEWERS_SUCCESS: 'AWS_GET_ACCOUNT_VIEWERS_SUCCESS',
  AWS_GET_ACCOUNT_VIEWERS_ERROR: 'AWS_GET_ACCOUNT_VIEWERS_ERROR',
  AWS_GET_ACCOUNT_VIEWERS_CLEAR: 'AWS_GET_ACCOUNT_VIEWERS_CLEAR',

  /* Add Shared Account */
  AWS_ADD_ACCOUNT_VIEWER: 'AWS_ADD_ACCOUNT_VIEWER',
  AWS_ADD_ACCOUNT_VIEWER_SUCCESS: 'AWS_ADD_ACCOUNT_VIEWER_SUCCESS',
  AWS_ADD_ACCOUNT_VIEWER_ERROR: 'AWS_ADD_ACCOUNT_VIEWER_ERROR',
  AWS_ADD_ACCOUNT_VIEWER_CLEAR: 'AWS_ADD_ACCOUNT_VIEWER_CLEAR',

  /* Edit Shared Account */
  AWS_EDIT_ACCOUNT_VIEWER: 'AWS_EDIT_ACCOUNT_VIEWER',
  AWS_EDIT_ACCOUNT_VIEWER_SUCCESS: 'AWS_EDIT_ACCOUNT_VIEWER_SUCCESS',
  AWS_EDIT_ACCOUNT_VIEWER_ERROR: 'AWS_EDIT_ACCOUNT_VIEWER_ERROR',
  AWS_EDIT_ACCOUNT_VIEWER_CLEAR: 'AWS_EDIT_ACCOUNT_VIEWER_CLEAR',

  /* Delete Shared Account */
  AWS_DELETE_ACCOUNT_VIEWER: 'AWS_DELETE_ACCOUNT_VIEWER',
  AWS_DELETE_ACCOUNT_VIEWER_SUCCESS: 'AWS_DELETE_ACCOUNT_VIEWER_SUCCESS',
  AWS_DELETE_ACCOUNT_VIEWER_ERROR: 'AWS_DELETE_ACCOUNT_VIEWER_ERROR',
  AWS_DELETE_ACCOUNT_VIEWER_CLEAR: 'AWS_DELETE_ACCOUNT_VIEWER_CLEAR'
};



// WEBPACK FOOTER //
// ./src/constants/aws/accountsTypes.js